import type { ProductModel } from './ProductModel'

export enum InventoryDisplay {
  CALL_FOR_AVAILABILITY,
  SHOW_ZERO,
  AVAILABLE_AT_LOCATION,
}

export interface ProductCardProps {
  product: ProductModel
  alternateFor?: ProductModel
  replacementFor?: ProductModel
  green?: boolean
}
